import { Breakpoint } from 'shared/types/Breakpoint'
import styles from './FilterButton.module.css'
import { LocationSettingsIcon } from 'shared/icons/LocationSettingsIcon'
import { DEFAULT_BREAKPOINTS } from 'shared/constants/breakpointsWidth'
import classNames from 'classnames'
import { useBreakpointUp } from 'shared/hooks/useBreakpointQueries'
import { useMemo } from 'react'
import { filtersToString } from 'shared/lib/filtersToString'

interface Filters{
    
}

interface FilterButtonProps {
    active: boolean
    className?: string
    filters: any
    ref?: any
    onClick?: (event: any) => void
}

export const FilterButton = (props: FilterButtonProps): JSX.Element => {
    const {
        active,
        className,
        filters,
        ref,
        onClick
    } = props

    const breakpointUpXl = useBreakpointUp('xl')
    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    const hasValue = filters!== undefined && (filters['bedrooms'].length > 0 || filters['beds'].length > 0 || filters['pets'].length > 0)

    const heading = useMemo(() => {
        if (hasValue){
            return `Filters`
        }

        return 'Select filters'
    }, [
        filters
    ])

    const caption = useMemo(
        () => {
            return filtersToString(filters)  
        },[
            filters,
        ]
    )

    const renderValue = useMemo(
        (): JSX.Element => {
            if (filters === undefined){
                return (
                    <></>
                )
            }

            const valueString = caption

            return (
                <span className={styles.FilterButton__ValueContainer}>
                    <span className={styles.FilterButton__ValueCaption}>
                        {valueString}
                    </span>
                </span>
            )
        },[
            filters,
        ]
    )

    if (breakpointUpXl === true) {
        const filterButtonCssClasses = classNames(styles.FilterButton, className, {
            [styles[`FilterButton--Active`]]: active,
            [styles[`FilterButton--HasValue`]]: filters !== undefined
        })

        return (
            <button
                ref={ref}
                className={filterButtonCssClasses}
                onClick={handleButtonClick}
            >
                <span className={styles.FilterButton__HelperContainer}>
                    <span className={styles.FilterButton__IconContainer}>
                        <LocationSettingsIcon
                            className={styles.FilterButton__Icon}
                        />
                    </span>
                    <span className={styles.FilterButton__CaptionContainer}>
                        <span className={styles.FilterButton__Caption}>{heading}</span>
                    </span>
                </span>
                {
                  renderValue
                }
            </button>   
        )
    }

    const filterButtonCssClasses = classNames(
        styles.FilterButton,
        styles[`FilterButton--WidthBreakPointMd`]
    )

    return (
        <button
            className={filterButtonCssClasses}
            onClick={handleButtonClick}
        >
            <span className={styles.FilterButton__IconContainer}>
                <LocationSettingsIcon className={styles.FilterButton__Icon} />
            </span>
        </button>
    )
}